<div class="row">
    <div class="col-12">
      <ngx-table #table [configuration]="configuration" [data]="data" [columns]="columns" ></ngx-table>
    </div>

</div>
